import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';

import AdmissionProcessStagesEditor from './parts/AdmissionProcessStagesEditor';
import AdmissionProcessDetailsForm from './parts/AdmissionProcessDetailsForm';
import {
  AdmissionProcessManagementLoaderProvider,
  useAdmissionProcessManagementLoader,
} from './parts/managementLoader';
import Loading from '../../../components/info/Loading';
import ProcessOffersList from './parts/ProcessOffersList';
import FormLoader from './parts/FormLoader';
import GoBackToListButton from '../../../components/buttons/GoBackToListButton';

function AdmissionProcessManagementContent({
  processTypes,
}: {
  processTypes: any[];
}) {
  const { t } = useTranslation('academic-offer/admission-processes');
  const { data, loading, refresh } = useAdmissionProcessManagementLoader();

  if (loading) return <Loading insideCard />;

  if (!data) {
    return <div>{t('errors.notFound')}</div>;
  }

  const { process, availableOffers } = data;
  return (
    <div className="mx-3 mt-2">
      <GoBackToListButton path="/academic-offer/admission-processes" />
      <p className="fs-16 mb-4 mt-4">{t('management.description')}</p>

      <AdmissionProcessDetailsForm
        process={process}
        refresh={refresh}
        processTypes={processTypes}
      />

      <AdmissionProcessStagesEditor
        stages={process.stages}
        processId={process.id}
      />

      <ProcessOffersList
        offers={process.offers}
        availableOffers={availableOffers}
        processFirstInstallmentRuleId={process.firstInstallmentRule?.id}
        refresh={refresh}
      />
    </div>
  );
}

export default function AdmissionProcessManagement() {
  const { id } = useParams<{ id: string }>();

  return (
    <Card className="p-4 mx-3">
      <FormLoader>
        {({ data: formData }) => (
          <AdmissionProcessManagementLoaderProvider
            defaultQuery={{ id: Number(id) }}
            fetchImmediately
          >
            <AdmissionProcessManagementContent
              processTypes={formData.processTypes}
            />
          </AdmissionProcessManagementLoaderProvider>
        )}
      </FormLoader>
    </Card>
  );
}
